export default __webpack_public_path__ + "static/media/GotTeaNewLogo.807012de.svg";